<template>
  <div class="aboutus">
    <img class="fi" :src="require(is1920 ? '../assets/aboutus.png' : '../assets/aboutus2880.png')"/>
    <div class="main">
      <div class="h_01_title">
        公司简介
      </div>
      <div class="prompt_01">
        <p>国恒智慧能源服务有限公司致力于社区新能源基础设施的研发、建设、推广及运营，为个人及企业提供完整的社区能源服务解决方案。公司目前主要聚焦于新能源汽车社区充电基础设施解决方案的建设，已自主研发了智慧充电桩、智慧充电云平台、充电APP等多款软硬件产品。</p>
        <p>国恒充电桩采用能源互联网和泛在电力物联网等先进技术，通过智能调度、有序充电等策略，实现社区用电的削峰填谷，解决电力容量不足、充电难、充电贵等社区充电问题，为社区提供智慧充电系统集成化解决方案。</p>
        <p>国恒充电APP提供错峰引导、有序充电等功能，可通过APP实现低谷充电自动预约以及充电费用自动结算，为用户提供快捷、方便、经济的充电服务。</p>
        <p>国恒充电云平台利用云计算、大数据、人工智能等技术，实时监控充电经营数据、充电终端与社区电力负荷，实现运维管理智能化以及运营数据可视化，为充电站的投建与运营提供决策支撑。</p>
      </div>
      <img class="map" :src="require(is1920 ? '../assets/map.png' : '../assets/map2880.png')"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'aboutus',
  inject: ['is1920']
}
</script>
<style lang="less">
.aboutus{
  width: 100%;
  .fi{
    display: block;
    width: 100%;
    height: 6rem;
  }
  .main{
    position: relative;
    width: 100%;
    padding: .65rem 3.6rem;
    text-align: left;
    background-color: white;
    .h_01{
      font-size: .8rem;
      line-height: 1.12rem;
      color: #73D6D0;
    }
    .h_01_title{
      font-size: .4rem;
      line-height: .56rem;
      color: #000;
      margin: .3rem 0;
    }
    .prompt_01{
      font-size: .18rem;
      color: #666;
      line-height: .25rem;
      p{
        margin-bottom: .31rem;
        word-wrap: break-word;
        word-break: break-all;
        text-indent: 2em;
      }
    }
    .map{
      margin: 0 .06rem;
      width: 11.88rem;
      height: 12.33rem;
    }
  }
}
</style>
